

import { Vue, Prop, Component } from "vue-property-decorator"
import VueSelect from "vue-select"
import { TimeZone } from "@/types"
import { TimeZoneAlias } from "@/types/timeZone"
import Guid from "@/scripts/guid"
import cloneDeep from "lodash/cloneDeep"

@Component({
	components: {
		"v-select": VueSelect
	}
})
export default class TimezoneAliases extends Vue {
	@Prop({ type: Array, default: () => [] })
	public value!: TimeZoneAlias[]

	@Prop({ type: Array })
	timeZones!: TimeZone[]

	visible: boolean = false

	mounted () {
		let test = false

		// sort the timezones on initial load but not while editing
		const sortedValue = this.value.sort((a, b) => {
			const timezoneAIndex = this.timeZones.findIndex(tz => tz.id === a.timezone)
			const timezoneBIndex = this.timeZones.findIndex(tz => tz.id === b.timezone)

			if (timezoneAIndex < timezoneBIndex) {
				return -1
			} else if (timezoneBIndex > timezoneAIndex) {
				return 1
			}
			return 0
		})

		this.$emit("input", sortedValue)
	}

	get filteredTimeZones () {
		return this.timeZones?.filter((timezone: TimeZone) => {
			return !this.value?.some((alias: TimeZoneAlias) => {
				return alias.timezone === timezone.id
			})
		}) ?? []
	}

	async rowTimezoneChanged (option: TimeZone, item: TimeZoneAlias) {
		if (item.id === null) {
			// new alias
			let newValue = this.value ? cloneDeep(this.value) : []

			const newAlias = {
				id: Guid.newGuid(),
				timezone: option.id,
				alias: item.alias ?? ""
			} as TimeZoneAlias

			newValue.push(newAlias)

			this.$emit("input", newValue)

			await this.$nextTick()

			const aliasInput = document.getElementById("timezone-alias-input-" + newAlias.id)
			if (aliasInput) aliasInput.focus()
			return
		}

		let newValue = this.value ? cloneDeep(this.value) : []
		newValue.find(alias => alias.id === item.id)!.timezone = option.id

		this.$emit("input", newValue)
	}

	rowAliasChanged (alias: string, item: TimeZoneAlias) {
		if (item.id === null) {
			// new alias, create when a time zone is picked, not when alias set
			item.alias = alias
			return
		}

		let newValue = this.value ? cloneDeep(this.value) : []
		newValue.find(alias => alias.id === item.id)!.alias = alias

		this.$emit("input", newValue)
	}

	removeRow (item: TimeZoneAlias) {
		let newValue = this.value ? cloneDeep(this.value) : []
		const removeIndex = newValue.findIndex(alias => alias.id === item.id)
		newValue.splice(removeIndex, 1)

		this.$emit("input", newValue)
	}

	get tableValues () {
		let aliasRows: (TimeZoneAlias | {})[] = [...(this.value ?? [])]
		if (this.filteredTimeZones.length > 0) {
			aliasRows.push({ id: null, timezone: null, alias: null })
		}
		return aliasRows
	}
}
